import {Card} from "../../../components/card/card.jsx";
import Button from "../../../components/button/button.jsx";
const EntityActionCard = ({ onSave,
                            onDelete,
                            showDeleteButton = false,
                            disableDeleteButton = false,
                            disableSaveButton = false,
                            cardClassName = "",
                            cardBodyClassName = "",
                            saveButtonProps,
                            deleteButtonProps,
                            children
}) => {

  if(children){
    return (
      <Card className={cardClassName}>
        <Card.Body className={`w-full flex justify-end gap-2 ${cardBodyClassName}`}>
          {children}
        </Card.Body>
      </Card>
    )
  }

  return(
    <Card className={`${cardClassName}`}>
      <Card.Body className={`w-full flex justify-end gap-2 ${cardBodyClassName}`}>
        { onDelete && showDeleteButton &&
          <EntityActionCard.Button
            onClick={onDelete}
            disabled={disableDeleteButton}
            target="danger"
            label="Excluir"
            {...deleteButtonProps}
          />
        }
        { onSave &&
          <EntityActionCard.Button
            onClick={onSave}
            disabled={disableSaveButton}
            label="Salvar"
            {...saveButtonProps}
          />
        }
      </Card.Body>
    </Card>
  )
}

EntityActionCard.Button = ({onClick, disabled, label, target, ...props}) => {
  const actionFeedbackType = label === "Excluir" || target === "danger" ? "delete" : "save";

  return (
    <Button target={target} disabled={disabled} onClick={onClick} actionFeedbackType={actionFeedbackType} {...props}>
    {label}
    </Button>
  );
}

EntityActionCard.Button.displayName = "EntityActionCard.Button";

export default EntityActionCard;